<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('data.title')"></page-header-title>
    </v-app-bar>

    <v-card>
      <v-card-text>
        <v-flex xs12 class="pa-3">
          <router-link :to="{ path: BACKEND_URL + '/data/import' }">
            <action-button type="upload" :text="$t('data.import_title')" />
          </router-link>

          <router-link :to="{ path: BACKEND_URL + '/data/export' }">
            <action-button type="edit" :text="$t('data.export_title')" />
          </router-link>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "DataManagement"
}
</script>